export default {
  REMARK_UNITS: "student/units",
  EXAM_REMARK: "exams/remark",
  PATCH_EXAM_REMARK: "exams/remark/update",
  SHOW_EXAM_REMARK: (id) => `exams/remark/show?no=${id}`,
  DELETE_EXAM_REMARK: "exams/remark/delete",
  deleteLine: "exams/remark/deleteLine",
  deleteAttachment: "exams/remark/deleteAttachment",
  proforma: (requestNo) =>
    `cu/PEGASUS_CU/SchoolManagement_getRequestProFormaInvoice?requestNo=${requestNo}`,
  receipt: (id) =>
    `cu/PEGASUS_CU/SchoolManagement_getReceiptReport?receiptNo=${id}`,
  checkCanApplyForRemark: "exams/remark/checkCanApplyForRemark",
};
